module.exports = {"name":"GrowthPage","parameters":[{"name":"fullStoryB2CEnabled","valid":[false,true],"value":false}]}